import _ from 'lodash';
import React from 'react';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import { Field, reduxForm } from 'redux-form';
import SelectableRowField from '../Fields/SelectableRows/SelectableRowField.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import SentenceSelectorInputField from '../Fields/SentenceSelectorInputField.jsx';

const validate = values => {
  const errors = {};

  if (!values.business) {
    errors.business = 'required';
  }
  return errors;
};

@reduxForm({ form: 'WitcoActivationSetupForm', validate })
@connect(state => ({ form: state.form.WitcoActivationSetupForm }))
class WitcoActivationSetupForm extends React.Component {
  
  render() {
    const { buildings, form } = this.props;
    const buildingsOptions = _.map(buildings, building => ({
      name: building.name,
      id: building.id,
      type: { name: 'Building' },
    }));

    const syncAllUsers = form && form.values && form.values.syncAllUsers;
    const syncReservations = form && form.values && form.values.syncReservations;

    return (
      <div>
        <h4 style={{ color: '#3f3f3f', textAlign: 'start', marginTop: 40, marginBottom: 10, fontWeight: 'bold' }}><Entity entity="witcoSelectBuildingsTitle" /></h4>
        <h4 style={{ color: '#3f3f3f', textAlign: 'start', marginTop: 0, marginBottom: 20, fontSize: '1.1em' }}><Entity entity="witcoSelectBuildingsSubtitle" /></h4>
        <Field
          name="buildings"
          component={SelectableRowField}
          options={{
            content: buildingsOptions,
          }}
          listContainerStyle={{ marginTop: 0, marginBottom: 30 }}
          listStyle={{ marginTop: 0 }}
        />
        <Divider />
        <div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottomWidth: 0 }}>
          <Field
            name="coldStartResources"
            label={<Entity entity="synchronizeAllResource" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f', marginTop: 30, marginBottom: 30 }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 40, marginTop: -10 }}><Entity entity="synchronizeAllResourcesWhenActivate" /></h5>
        </div>
        <div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 0, borderBottomWidth: 0 }}>
          <Field
            name="syncAllUsers"
            label={<Entity entity="synchronizeAllUsers" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f', marginTop: 30, marginBottom: 30 }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 40, marginTop: -10 }}><Entity entity="synchronizeAllUsersWhenActivate" /></h5>
        </div>
        <div style={{ border: '1px solid #ccc', padding: 10, borderRadius: 5, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
          <Field
            name="syncReservations"
            label={<Entity entity="synchronizeAllReservations" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f', marginTop: 30, marginBottom: 30 }}
            component={MDCheckBoxField}
          />
          <h5 style={{ marginBottom: 40, marginTop: -10 }}><Entity entity="synchronizeAllReservationsWhenActivate" /></h5>
          {syncReservations && (
            <div>
              <Divider />
              <h4 style={{ marginBottom: 20, marginTop: 20, fontSize: '1.1em', marginLeft: 30 }}><Entity entity="synchronizeReservationsAsChoose2" /></h4>
              <Field
                name="pin"
                label={<Entity entity="synchronizeReservationsAsPinsTitle" />}
                titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
                containerstyle={{ marginLeft: 30 }}
                component={MDCheckBoxField}
              />
              <h5 style={{ marginBottom: 20, marginTop: -10, marginLeft: 30 }}><Entity entity="synchronizeReservationsAsPins" /></h5>
              <Field
                name="credentialRule"
                label={<Entity entity="synchronizeReservationsAsCredentialRulesTitle" />}
                titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
                containerstyle={{ marginLeft: 30 }}
                component={MDCheckBoxField}
              />
              <h5 style={{ marginBottom: 20, marginTop: -10, marginLeft: 30 }}><Entity entity="synchronizeReservationsAsCredentialRules" /></h5>
              <Field
                name="invitation"
                label={<Entity entity="synchronizeReservationsAsInvitationsTitle" />}
                titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
                containerstyle={{ marginLeft: 30 }}
                component={MDCheckBoxField}
              />
              <h5 style={{ marginBottom: 50, marginTop: -10, marginLeft: 30 }}><Entity entity="synchronizeReservationsAsInvitations" /></h5>
            </div>
          )}
          {syncReservations && (
            <div style={{ marginTop: 0 }}>
              <Divider />
              <Field
                name="syncReservationsNoNewUsers"
                label={<Entity entity="synchronizeAllReservationsNoNewUsers" />}
                titleStyle={{ fontSize: 16, color: '#3f3f3f', marginTop: 0, marginBottom: 0 }}
                containerstyle={{ marginLeft: 30, marginTop: 20 }}
                component={MDCheckBoxField}
              />
              <h5 style={{ marginBottom: 40, marginTop: -10, marginLeft: 30 }}><Entity entity="synchronizeAllReservationsNoNewUsersSubtitle" /></h5>
            </div>
          )}
          {syncReservations && !syncAllUsers && (
            <div style={{ marginTop: 0 }}>
              <Divider />
              <Field
                id="allowAccessMinutesBefore"
                name="allowAccessMinutesBefore"
                component={SentenceSelectorInputField}
                disabled={false}
                containerStyle={{ marginTop: 10, marginLeft: 30 }}
                sentence={L20NContext.getSync('allowAccessMinutesBeforeSentence')}
              />
              <Divider style={{marginTop: 20, marginBottom: 10}} />
              <Field
                id="allowAccessMinutesAfter"
                name="allowAccessMinutesAfter"
                component={SentenceSelectorInputField}
                disabled={false}
                containerStyle={{ marginTop: 10, marginLeft: 30 }}
                sentence={L20NContext.getSync('allowAccessMinutesAfterSentence')}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
} 

export default WitcoActivationSetupForm;
